/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@atlaskit/css';
import {
	CardAction,
	ElementName,
	SmartLinkPosition,
	SmartLinkSize,
	TitleBlock,
} from '@atlaskit/smart-card';
import { CardSSR as Card } from '@atlaskit/smart-card/ssr';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
/**
 * this is a copy of SimpleInlineSmartLink, need some more work to make it work for atlas project
 * for now, we are using this component to avoid breaking changes
 * update SimpleInlineSmartLink with the changes made here later if possible
 * ticket: https://jplat.atlassian.net/browse/ANIP-217
 */
const uiOptions = {
	clickableContainer: true,
	hideBackground: true,
	hideElevation: true,
	hidePadding: true,
	size: SmartLinkSize.Medium,
};

const actionOptions = {
	hide: false,
	exclude: [CardAction.ChangeStatusAction],
};

type TitleBlockProps = Parameters<typeof TitleBlock>[0];
type BaseSmartLinkProps = Parameters<typeof Card>[0];
type Props = Pick<BaseSmartLinkProps, 'url' | 'showHoverPreview' | 'onError'> &
	Pick<
		TitleBlockProps,
		| 'anchorRef'
		| 'anchorTarget'
		| 'text'
		| 'metadata'
		| 'actions'
		| 'position'
		| 'icon'
		| 'hideRetry'
	> & {
		/** When defined this will display a remove button after the link that calls `onRemove` when clicked. */
		onRemove?: () => void;
	};

export const SimpleInlineSmartLink = ({
	url,
	anchorTarget,
	showHoverPreview = true,
	text,
	anchorRef,
	onError,
	metadata = [{ name: ElementName.State }],
	position = SmartLinkPosition.Center,
	actions,
	icon,
	hideRetry,
}: Props) => {
	return (
		<Box paddingBlock="space.025" paddingInline="space.050" xcss={inlineStyles}>
			<Card
				appearance="inline"
				url={url}
				ui={uiOptions}
				actionOptions={actionOptions}
				showHoverPreview={showHoverPreview}
				onError={onError}
			>
				<TitleBlock
					hideTitleTooltip
					maxLines={1}
					metadata={metadata}
					anchorTarget={anchorTarget ?? '_self'}
					text={text}
					icon={icon}
					css={titleBlockStyles}
					anchorRef={anchorRef}
					position={position}
					actions={actions}
					hideRetry={hideRetry}
				/>
			</Card>
		</Box>
	);
};

const inlineStyles = xcss({
	backgroundColor: 'elevation.surface.raised',
	borderColor: 'color.border',
	borderStyle: 'solid',
	borderWidth: 'border.width',
	borderRadius: 'radius.small',
	display: 'inline-flex',
	gap: 'space.050',
});

const titleBlockStyles = css({
	gap: token('space.050'),
	height: '24px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});
